<div class="select-guest-confirmation-container">
  <div class="heading-container flex-row flex-justify-space-between flex-align-center">
    <h2 mat-dialog-title translate="VOLUNTEER.CONFIRMATION_DIALOG.CONFIRM_TITLE" [translateParams]="itemTypeParam"></h2>
    <button mat-button class="close-icon" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="flex-row">
      <p>
        {{ 'VOLUNTEER.CONFIRMATION_DIALOG.CONFIRM_INFO' | translate: itemTypeParam }}
        <strong>{{ data.profile | gbDisplayName }}</strong
        >.
      </p>
    </div>
    <div class="confirm-amount flex-row">
      <p>
        {{ 'VOLUNTEER.CONFIRMATION_DIALOG.AMOUNT' | translate }}:
        <strong>{{ data.paymentAmount | gbCurrency }}</strong>
      </p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="gb-flex-button-container flex-grow">
      <button mat-stroked-button translate="VOLUNTEER.CONFIRMATION_DIALOG.CANCEL" mat-dialog-close></button>
      <button
        mat-raised-button
        color="primary"
        translate="VOLUNTEER.CONFIRMATION_DIALOG.CONFIRM"
        [mat-dialog-close]="'success'"
      ></button>
    </div>
  </mat-dialog-actions>
</div>
